import { useTelegramSafeAreas } from './PageLayout'

/**
 * TopSafeSpacer — top clearance for pages that don't use PageLayout.
 *
 * Uses the SAME computed Telegram safe-area inset as PageLayout so these pages
 * line up with the rest of the app. Replaces the old hardcoded
 * `calc(10vh + env(safe-area-inset-top))` spacer, which left a large empty white
 * band under the Telegram header on tall screens.
 */
export default function TopSafeSpacer() {
  const safeAreas = useTelegramSafeAreas()
  return <div style={{ paddingTop: `${safeAreas.top}px` }} />
}
